import { render, staticRenderFns } from "./OccupationDetails.vue?vue&type=template&id=4811523c&scoped=true&"
import script from "./OccupationDetails.vue?vue&type=script&lang=js&"
export * from "./OccupationDetails.vue?vue&type=script&lang=js&"
import style0 from "./OccupationDetails.vue?vue&type=style&index=0&id=4811523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811523c",
  null
  
)

export default component.exports